<div class="navbar navbar-expand-lg fixed-top navbar-dark bg-dark">
  <div class="row">
      <div style="width:'225px'">
        <img src="../../../assets/images/general/LOGO ACIERTO BLANCO.png" height="40px">
      </div>
      <div>
        <p class="subtitle">{{title}}</p>
      </div>
  </div>
</div>
